import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon, Button, message } from 'antd';
import styled from 'styled-components';
import { request } from '~/_shared/instance';

const CHECKOUT_BASE_URL = 'https://checkout.contlabs.com.br';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 12px;
  font-size: 14px;
  background: ${(props) => props.bg};
  border: 1px solid ${(props) => props.border};
  color: ${(props) => props.color};

  .trial-text {
    font-weight: 500;
  }

  .trial-days {
    font-weight: 700;
  }
`;

const getTheme = (daysLeft) => {
  if (daysLeft <= 0) {
    return { bg: '#fff1f0', border: '#ffa39e', color: '#a8071a', icon: 'clock-circle' };
  }
  if (daysLeft <= 3) {
    return { bg: '#fff1f0', border: '#ffccc7', color: '#cf1322', icon: 'clock-circle' };
  }
  if (daysLeft <= 7) {
    return { bg: '#fffbe6', border: '#ffe58f', color: '#ad6800', icon: 'clock-circle' };
  }
  return { bg: '#f9f0ff', border: '#d3adf7', color: '#531dab', icon: 'rocket' };
};

const TrialBanner = () => {
  const [opening, setOpening] = useState(false);
  const user = useSelector((state) => state.user);

  const tenant = user && user.tenant;

  // Só tenants em trial: com prazo definido (signups novos) e sem assinatura.
  if (!tenant || !tenant.trial_ends_at || tenant.payment_subscription_id) {
    return null;
  }

  const msLeft = new Date(tenant.trial_ends_at).getTime() - Date.now();
  const daysLeft = Math.max(0, Math.ceil(msLeft / (24 * 60 * 60 * 1000)));
  const theme = getTheme(daysLeft);

  const openCheckout = () => {
    setOpening(true);
    request('get', '/auth/subscription/checkout-link', null, false)
      .then((res) => {
        const token = res && res.data && res.data.data && res.data.data.token;
        if (token) {
          window.open(CHECKOUT_BASE_URL + '/' + token, '_blank');
        } else {
          message.error('Não foi possível abrir o checkout. Tente novamente.');
        }
      })
      .catch(() => {
        message.error('Não foi possível abrir o checkout. Tente novamente.');
      })
      .then(() => setOpening(false));
  };

  return (
    <Bar bg={theme.bg} border={theme.border} color={theme.color}>
      <Icon type={theme.icon} />
      <span className="trial-text">
        {daysLeft <= 0 && 'Seu período de teste terminou — assine para continuar usando todos os recursos.'}
        {daysLeft === 1 && (
          <>Último dia do seu período de teste!</>
        )}
        {daysLeft > 1 && (
          <>Você tem <span className="trial-days">{daysLeft} dias</span> restantes no período de teste.</>
        )}
      </span>
      <Button
        size="small"
        type={daysLeft <= 3 ? 'danger' : 'primary'}
        loading={opening}
        onClick={openCheckout}
      >
        Assinar agora
      </Button>
    </Bar>
  );
};

export default TrialBanner;
